import * as React from "react";
function SvgVkontakteGroup(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M29.4 15.91a21 21 0 002.23-3.8c.07-.34-.08-.52-.43-.52h-1.76a.64.64 0 00-.67.43 15.92 15.92 0 01-2.11 3.3c-.37.41-.56.54-.76.54s-.24-.14-.24-.51v-3.26c0-.46-.05-.59-.43-.59h-2.82a.31.31 0 00-.35.3c0 .43.66.53.66 1.69v2.4c0 .48 0 .67-.25.67-.6 0-2-2.08-2.84-4.44-.16-.48-.34-.62-.79-.62h-1.77a.42.42 0 00-.44.43c0 .47.55 2.64 2.71 5.55a6.66 6.66 0 005.07 3c1 0 1.3-.17 1.3-.62v-1.5c0-.38.15-.54.36-.54s.67.08 1.66 1.06c1.18 1.13 1.26 1.6 1.9 1.6h2c.2 0 .39-.09.39-.43a4.76 4.76 0 00-1.46-2.17c-.36-.48-1-1-1.14-1.25s-.21-.42-.02-.72z" />
      <path d="M15.45 9.72A9 9 0 1018 16.89a9 9 0 00-2.55-7.17zm1.61 7.08a8.1 8.1 0 11-2.26-6.46 8.11 8.11 0 012.26 6.47z" />
      <path d="M13 16.53a2.22 2.22 0 10-2.16-3.88 3.22 3.22 0 10-4.48 4 5 5 0 00-3.09 4.28v.45h2.4v-.9H4.18a4.09 4.09 0 013.63-3.22 4.09 4.09 0 013.63 3.22H9.23v.9h3.15v-.45a4.83 4.83 0 00-1.71-3.42 2.77 2.77 0 011.33-.29 2.49 2.49 0 012.06 1.84h-1.23V20H15v-.45a3.58 3.58 0 00-2-3.02zm-1-3.31a1.33 1.33 0 11-1.19 1.92 3.19 3.19 0 00.19-1.32v-.22a1.33 1.33 0 01.94-.38zm-6.45.6a2.32 2.32 0 112.32 2.32 2.33 2.33 0 01-2.38-2.32zm3.8 2.85a3.22 3.22 0 00.85-.67 2.22 2.22 0 00.63.53 2.8 2.8 0 00-.92.48 4.51 4.51 0 00-.62-.34z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgVkontakteGroup);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
